const sowOptions = [
	{
		title: 'SOW_OPTION_SALARY',
		subtitle: 'SOW_OPTION_SALARY_DESCRIPTION',
		value: 'SOW_OPTION_SALARY'
	},
	{
		title: 'SOW_OPTION_INVESTMENT',
		subtitle: 'SOW_OPTION_INVESTMENT_DESCRIPTION',
		value: 'SOW_OPTION_INVESTMENT'
	},
	{
		title: 'SOW_OPTION_ASSETS',
		subtitle: 'SOW_OPTION_ASSETS_DESCRIPTION',
		value: 'SOW_OPTION_ASSETS'
	},
	{
		title: 'SOW_OPTION_TRADING',
		subtitle: 'SOW_OPTION_TRADING_DESCRIPTION',
		value: 'SOW_OPTION_TRADING'
	},
	{
		title: 'SOW_OPTION_WINNINGS',
		subtitle: 'SOW_OPTION_WINNINGS_DESCRIPTION',
		value: 'SOW_OPTION_WINNINGS'
	},
	{
		title: 'SOW_OPTION_DIVORCE',
		subtitle: 'SOW_OPTION_DIVORCE_DESCRIPTION',
		value: 'SOW_OPTION_DIVORCE'
	},
	{
		title: 'SOW_OPTION_INHERITANCE',
		subtitle: 'SOW_OPTION_INHERITANCE_DESCRIPTION',
		value: 'SOW_OPTION_INHERITANCE'
	},
	{
		title: 'SOW_OPTION_DIVIDENDS',
		subtitle: 'SOW_OPTION_DIVIDENDS_DESCRIPTION',
		value: 'SOW_OPTION_DIVIDENDS'
	},
	{
		title: 'SOW_OPTION_GIFT',
		subtitle: 'SOW_OPTION_GIFT_DESCRIPTION',
		value: 'SOW_OPTION_GIFT'
	},
	{
		title: 'SOW_OPTION_SALEOFPROPERTY',
		subtitle: 'SOW_OPTION_SALEOFPROPERTY_DESCRIPTION',
		value: 'SOW_OPTION_SALEOFPROPERTY'
	},
	{
		title: 'SOW_OPTION_SALEOFCOMPANY',
		subtitle: 'SOW_OPTION_SALEOFCOMPANY_DESCRIPTION',
		value: 'SOW_OPTION_SALEOFCOMPANY'
	},
	{
		title: 'SOW_OPTION_OTHER',
		isCustom: true,
		placeholder: 'SOW_OTHER_OPTIONS_PLACEHOLDER_TEXT'
	}
];

export default sowOptions;
